import { render, staticRenderFns } from "./showDetails.vue?vue&type=template&id=eb83dbcc&scoped=true&"
import script from "./showDetails.vue?vue&type=script&lang=js&"
export * from "./showDetails.vue?vue&type=script&lang=js&"
import style0 from "./showDetails.vue?vue&type=style&index=0&id=eb83dbcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb83dbcc",
  null
  
)

export default component.exports